import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { depreciationMethodNameConfig } from './DepreciationMethod.name';

enum DepreciationMethod {
  twoHundredDclBalMethod = '10',
  twoHundredFiftyDclBalMethod = '11',
  straightLineMethod = '20',
  monthlyInstallmentDepreciation = '30',
  equalDepreciation = '31',
  immediateDepreciation = '40',
  oldDclBalMethod = '50',
  oldStraightLineMethod = '51',
  nonDepreciation = '60',
}

const depreciationMethodMap = new Map([
  ['10', DepreciationMethod.twoHundredDclBalMethod],
  ['11', DepreciationMethod.twoHundredFiftyDclBalMethod],
  ['20', DepreciationMethod.straightLineMethod],
  ['30', DepreciationMethod.monthlyInstallmentDepreciation],
  ['31', DepreciationMethod.equalDepreciation],
  ['40', DepreciationMethod.immediateDepreciation],
  ['50', DepreciationMethod.oldDclBalMethod],
  ['51', DepreciationMethod.oldStraightLineMethod],
  ['60', DepreciationMethod.nonDepreciation],
]);

const rawValueMayToDepreciationMethod = rawValueToEnumWithDefault(depreciationMethodMap, '');

const depreciationMethodToDisplay = enumToNameWithDefault(DepreciationMethod, depreciationMethodNameConfig);

const depreciationMethodToDisplayWithPrefix = enumToNameWithDefault(
  DepreciationMethod,
  depreciationMethodNameConfig,
  true,
);

export {
  DepreciationMethod,
  depreciationMethodToDisplay,
  depreciationMethodToDisplayWithPrefix,
  rawValueMayToDepreciationMethod,
};
